const eventSponsors = {

  corro_ninos_2026: {

    titulo: "NUESTROS AUSPICIADORES",

    sponsors: [

      {
        id: 1,
        imagen: "https://ik.imagekit.io/twn1y7ldf/Nuevo_ATACA/CORRO%20POR%20LOS%20NINOS%202026/MUNICHARACATO.png",
        link: "https://web.facebook.com/characatomunicipalidad",
        alt: "Municipalidad de Characato"
      },

      {
        id: 2,
        imagen: "https://ik.imagekit.io/twn1y7ldf/Nuevo_ATACA/CORRO%20POR%20LOS%20NINOS%202026/Claro.svg.webp",
        link: "https://www.claro.com.pe/personas/",
        alt: "Claro"
      },
      {
        id: 3,
        imagen: "https://ik.imagekit.io/twn1y7ldf/Nuevo_ATACA/CORRO%20POR%20LOS%20NINOS%202026/AYUDANOS.jpg",
        link: "https://web.facebook.com/ayudanosayudaraqp",
        alt: "Ayudanos a ayudar"
      },
    ]

  }

};

export default eventSponsors;